"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCaiforniaRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _Rule = require("../Rule");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _types = require("../../assets/types");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'CA'; // ** These exceptions are for 703 filings only

function getCaiforniaRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), (0, _commonRules.thriftSavingsPlans)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Motor Vehicle (one)',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(2)',
    limitAggregateSingle: 4800,
    limitAggregateJoint: 4800,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _types.VEHICLE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Household Goods and Furnishings, Books, Antiques, Art, Collectibles, Hobby' + ' Equipment, Clothes, Animals, Crops, Musical Instruments',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    // NOTE: The norm is that lawyers list all household goods together, not itemized even though that's the statute.
    // limitPerItem: 600,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.HOUSEHOLD, _subTypes.BOOK, _subTypes.ANTIQUE, _subTypes.COLLECTIBLES, _subTypes.SPORTS_OR_HOBBY_EQUIPMENT, _subTypes.FAMILY_PHOTOS, _subTypes.CLOTHES, _subTypes.PERSONAL_ANIMALS, _subTypes.CROPS, _subTypes.MUSICAL_INSTRUMENT, _subTypes.FARM_ANIMALS, _subTypes.ELECTRONICS];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Jewelry',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(4)',
    limitAggregateSingle: 1425,
    limitAggregateJoint: 1425,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.JEWELRY, _subTypes.WATCH, _subTypes.WEDDING_RINGS];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Health aids',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(9)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA, IRA, ROTH IRA',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(10)(E)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validSubType = [_subTypes.IRA, _subTypes.RETIREMENT_401K, _subTypes.RETIREMENT_403B, _subTypes.RETIREMENT_PLAN, _subTypes.PENSION_PLAN];
      var validTertiaryTypes = [_tertiaryTypes.ERISA_REITREMENT_PLAN];
      return this.canTakeMoreExemptions() && (validSubType.includes(subType) || validTertiaryTypes.includes(tertiaryType));
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony or Maintenance Support',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(10)(D)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'Wrongful Death Awards',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(11)(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WRONGFUL_DEATH_AWARD;
    }
  }, {
    id: idCounter.increment(),
    description: 'Veterans\' Benefit',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(10)(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Assistance',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(10)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PUBLIC_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability or unemployment benefits',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(10)(C)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS || tertiaryType === _tertiaryTypes.UNEMPLOYMENT_BENEFITS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Crime victims\' compensation ',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(11)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Loss of future earnings ',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(11)(E)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.LOSS_OF_FUTURE_EARNINGS_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Injury Settlement',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(11)(D); Cal. Civ. Proc. Code § 703.140 (b)(11)(E)',
    limitAggregateSingle: 24060,
    limitAggregateJoint: 24060,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    requiresReview: true,
    description: 'Life insurance (unmatured, loan)',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(8)',
    limitAggregateSingle: 12860,
    limitAggregateJoint: 12860,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trade',
    type: stateCode,
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(6)',
    limitAggregateSingle: 7175,
    limitAggregateJoint: 7175,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.TOOLS_OF_TRADE;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    type: stateCode,
    requiresReview: true,
    description: 'Wildcard',
    statuteName: 'Cal. Civ. Proc. Code § 703.140 (b)(5); Cal. Civ. Proc. Code § 703.140 (b)(1)',
    // TODO: Setup transform since this exemption comes from homestead exemption not being in use
    limitAggregateSingle: 30835,
    limitAggregateJoint: 30835,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}